<template>
  <div class="dashboard-modules-activity-filters gap-5">
    <div class="dashboard-modules-activity-filters__filters">
      <filters-dropdown-coach
        :has-none-option="false"
        :selected-coach-id="selectedCoachId"
        class="mr-3 dashboard-modules-activity-filters__filter"
        @update:selected-coach-id="handleCoachSelection"
      >
      </filters-dropdown-coach>
      <filters-dropdown-periods
        class="dashboard-modules-activity-filters__filter"
        :query-name="`${this.moduleName}Period`"
        @select="setSelectedPeriod"
      >
      </filters-dropdown-periods>
    </div>
    <bc-button
      icon-left="refresh"
      type="outlined"
      :disabled="isLoading"
      @click="handleRefreshData"
    >
      {{ $t('generics.refresh-data') }}
    </bc-button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FiltersDropdownCoach from '@/components/Filters/FiltersDropdown/FiltersDropdownCoach.vue';
import FiltersDropdownPeriods from '@/components/Filters/FiltersDropdown/FiltersDropdownPeriods.vue';
import { mapStores } from 'pinia';
import { useStatisticsStore } from '@/store/pinia/statistics';
import BcButton from '@/ui-kit/components/BcButton';

export default {
  name: 'dashboard-modules-filters',
  components: { FiltersDropdownPeriods, FiltersDropdownCoach, BcButton },
  props: {
    moduleName: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      selectedCoachId: undefined,
    };
  },
  computed: {
    ...mapState({
      coaches: state => state.coaches?.coaches,
      profile: state => state.user.profile,
    }),
    ...mapStores(useStatisticsStore),
    isLoading() {
      return this.statisticsStore.isLoading;
    },
  },
  created() {
    this.selectedCoachId = this.statisticsStore?.coachId || undefined;

    this.$router.replace({
      ...this.$route,
      query: {
        ...this.$route.query,
        ...this.statisticsStore?.period ? { [`${this.moduleName}Period`]: this.statisticsStore.period } : {},
        ...this.statisticsStore?.startDate ? { [`${this.moduleName}Start`]: this.statisticsStore.startDate } : {},
        ...this.statisticsStore?.endDate ? { [`${this.moduleName}End`]: this.statisticsStore.endDate } : {},
      },
    }).catch(() => {});
  },
  methods: {
    handleCoachSelection(coachId) {
      this.selectedCoachId = coachId;
    },
    setSelectedPeriod(option) {
      this.$router.push({
        query: {
          ...this.$route.query,
          [`${this.moduleName}Period`]: option.query,
          [`${this.moduleName}Start`]: option.from,
          [`${this.moduleName}End`]: option.to,
        },
      }).catch(() => {});
    },
    handleRefreshData() {
      this.statisticsStore.getStatistics({
        coachId: this.selectedCoachId,
        period: this.$route.query[`${this.moduleName}Period`],
        startDate: this.$route.query[`${this.moduleName}Start`],
        endDate: this.$route.query[`${this.moduleName}End`],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-modules-activity-filters {
  &__filter {
    font-size: $font-size-s;
  }
}
</style>
